import { httpClient } from './http-client';
import { getEndpointUrl } from './api-config';

const isMock = import.meta.env.VITE_ENABLE_MOCK === 'true';

export interface VentaListItem {
  id: string;
  fechaVenta: string;
  adquirente: string;
  cuotaDisplay: string;
  abonoOriginal: number | null;
  commerceCode: string | null;
  authorizationCode: string | null;
}

export interface VentasListResponse {
  data: VentaListItem[];
  pagination: {
    page: number;
    pageSize: number;
    total: number;
    totalPages: number;
  };
  montoMinimo: number;
}

export interface CuotaItem {
  id: string;
  cuotaNum: number;
  totalCuotas: number;
  fechaAbono: string;
  montoOriginal: number;
  diasAdelanto: number;
  comisionFlux: number;
  recibiras: number;
}

export interface VentaCuotasResponse {
  ventaId: string;
  comisionFlux: number;
  tye: number;
  recibiras: number;
  cuotas: CuotaItem[];
  montoMinimo: number;
  /** Tasa TYE — necesaria para recalcular cuando el comercio selecciona un subset. */
  stampTaxRate?: number;
  /** Cap proporcional del TYE — `tye = MIN(base × N × rate, base × cap)`. */
  stampTaxCap?: number;
}

export interface VentasFilters {
  adquirente?: string;
  fechaDesde?: string;
  fechaHasta?: string;
  page?: number;
}

export interface EnviarOtpPayload {
  cuotaIds: string[];
}

export interface CrearSolicitudPayload {
  cuotaIds: string[];
  otpCode: string;
}

export const adelantosService = {
  async fetchVentas(filters: VentasFilters = {}): Promise<VentasListResponse> {
    const baseUrl = getEndpointUrl('adelantos', 'cuotas-disponibles');
    const params = new URLSearchParams();
    if (filters.page) params.set('page', String(filters.page));
    if (filters.adquirente) params.set('adquirente', filters.adquirente);
    if (filters.fechaDesde) params.set('fechaDesde', filters.fechaDesde);
    if (filters.fechaHasta) params.set('fechaHasta', filters.fechaHasta);
    const qs = params.toString();
    const url = qs ? `${baseUrl}?${qs}` : baseUrl;
    return httpClient.get<VentasListResponse>(url);
  },

  async fetchVentaCuotas(ventaId: string): Promise<VentaCuotasResponse> {
    const url = getEndpointUrl('adelantos', 'venta-cuotas').replace('{id}', ventaId);
    return httpClient.get<VentaCuotasResponse>(url);
  },

  async enviarOtp(payload: EnviarOtpPayload): Promise<void> {
    if (isMock) {
      await new Promise((r) => setTimeout(r, 400));
      return;
    }

    const url = getEndpointUrl('adelantos', 'enviar-otp');
    await httpClient.post(url, payload);
  },

  async crearSolicitud(payload: CrearSolicitudPayload): Promise<void> {
    if (isMock) {
      await new Promise((r) => setTimeout(r, 400));
      if (payload.otpCode !== '123456') {
        throw new Error('Código incorrecto. En modo mock el código es 123456');
      }
      return;
    }

    const url = getEndpointUrl('adelantos', 'crear-solicitud');
    await httpClient.post(url, payload);
  },
};
